import React, { useState, useEffect } from "react";
function Footer() {
  const path = window.location.pathname;

  return (

    <footer className="main-footer">
      <div className="row">
        <div className="col-12 col-md-5 mb-3 mb-md-0">
          <div className="footer_logotxt">Copyright © 2024</div>
        </div>
        {/* <div class="col-12 col-md-7">
  </div> */}
      </div>
    </footer>


  );
}

export default Footer;
